import { mapCaseToCss } from '@lib/theme/defaultTypography';
import styled from 'styled-components';
import { TOwnerState } from './typography.types';

export const TypographyRoot = styled.span<{ ownerState: TOwnerState }>(
  ({ theme, ownerState }) => ({
    margin: 0,
    color: theme.color.tint.primary,
    // @ts-expect-error
    ...theme.typography[ownerState.display][ownerState.variant],
    ...(ownerState.align !== 'inherit' && {
      textAlign: ownerState.align,
    }),
    ...(ownerState.noWrap && {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    }),
  }),

  ({ theme, ownerState }) =>
    // @ts-expect-error
    mapCaseToCss(theme.typography[ownerState.display][ownerState.variant].case),
);
